import { RefObject } from 'react';

export const isElementWithinRef = ({
  ref,
  element,
}: {
  ref: RefObject<HTMLElement | null>;
  element: Element | null;
}) => ref.current?.contains(element);
